import gql from 'graphql-tag';

const AGENTS_GET_OS = gql`
  query getOs {
    getOsResponse
      @rest(
        type: "GetOs"
        path: "/agents/agents_os/"
        method: "GET"
      ) {
      id
      name
    }
  }
`;

export default {
  AGENTS_GET_OS,
};